import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByDayCSV from './StatisticsByDayCSV';
import {
    getData,
    getHeaderName
} from './StatisticsByDayCSV.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: getData,
    headerName: getHeaderName
});

const StatisticsByDayCSVComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByDayCSV);

export default StatisticsByDayCSVComponent;
